<template>
  <div>
    <van-nav-bar @click-left="ReturnPage()" left-arrow>
      <template #left>
        <van-icon name="arrow-left" color="#000" size="22" />
      </template>
      <template #title>
        <p style="font-size: 13pt">
          {{ tools.GetLanguageValue("public.app.预览标题") }}
        </p>
      </template>
    </van-nav-bar>

    <!-- 套餐列表 -->

    <div
      class="item_content"
      v-for="collectionItem in PreviewsModel.Collections"
      :key="collectionItem.Id"
    >
      <div
        style="margin: 3px; display: flex"
        @click="StoreCollectionPreviewDetail(collectionItem)"
      >
        <div style="width: 100%">
          <div
            style="
              height: 30px;
              width: 100%;
              border-bottom: 1px solid #e6e6e6;
              line-height: 30px;
              display: flex;
              justify-content: space-between;
            "
          >
            <div class="previewName">
              {{ collectionItem.Name }}
            </div>
            <div style="color: red">
                      {{ collectionItem.PriceFormat }}
                    </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <van-image
              lazy-load
              style="width: 100px; margin: 5px; height: 80px"
              fit="contain"
              :src="collectionItem.CompleteImages"
            />

            <van-icon
                name="eye-o"
                color="#A6A6A6"
                style="margin-right: 13px; size: 18pt"
                size="20pt"
              />
            <!-- <van-button
            plain
            icon="eye-o"
            type="default"
            style="margin-right: 3px;"
            @click="StorePreviewDetail(ProductItem)"
          >
            {{ tools.GetLanguageValue("public.app.查看") }}
          </van-button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 分类列表 -->
    <div
      class="item_content"
      v-for="categoryItem in PreviewsModel.Categorys"
      :key="categoryItem.Id"
    >
      <div
        style="margin: 3px; display: flex"
        @click="StoreCategoryPreviewDetail(categoryItem)"
      >
        <div style="width: 100%">
          <div
            style="
              height: 30px;
              width: 100%;
              border-bottom: 1px solid #e6e6e6;
              line-height: 30px;
            "
          >
            <div class="previewName">
              {{ categoryItem.Name }}
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <van-image
              lazy-load
              style="width: 100px; margin: 5px; height: 80px"
              fit="contain"
              :src="categoryItem.ImagesFormat"
            />
            <van-icon
              name="eye-o"
              color="#A6A6A6"
              style="margin-right: 13px; size: 18pt"
              size="20pt"
            />
            <!-- <van-button
            plain
            icon="eye-o"
            type="default"
            style="margin-right: 3px;"
            @click="StorePreviewDetail(ProductItem)"
          >
            {{ tools.GetLanguageValue("public.app.查看") }}
          </van-button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 商品列表 -->
    <div
      class="item_content"
      v-for="ProductItem in PreviewsModel.Products"
      :key="ProductItem.Id"
    >
      <div
        style="margin: 3px; display: flex"
        @click="StorePreviewDetail(ProductItem)"
      >
        <div style="width: 100%">
          <div
            style="
              height: 30px;
              width: 100%;
              border-bottom: 1px solid #e6e6e6;
              line-height: 30px;
              display: flex;
              justify-content: space-between;
            "
          >
            <div class="previewName">
              {{ ProductItem.Name }}
            </div>
            <div style="color: red">
                      {{ ProductItem.PriceFormat }}
                    </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <van-image
              lazy-load
              style="width: 100px; margin: 5px; height: 80px"
              fit="contain"
              :src="ProductItem.CompleteImages"
            />
            <van-icon
              name="eye-o"
              color="#A6A6A6"
              style="margin-right: 13px; size: 18pt"
              size="20pt"
            />
            <!-- <van-button
            plain
            icon="eye-o"
            type="default"
            style="margin-right: 3px;"
            @click="StorePreviewDetail(ProductItem)"
          >
            {{ tools.GetLanguageValue("public.app.查看") }}
          </van-button> -->
          </div>
        </div>
      </div>
    </div>

    <br />
    <br />
    <br />
    <br />
  </div>
</template> 
<script>
import axios from "../../commons/AxiosMethod.js";
import productBbroadwise from "../../components/tabbars/StoreProductBroadwise.vue";
import tabbar from "../../components/tabbars/storeTabbar.vue";
import LanguageSelect from "../../components/LanguageSelect.vue";
import tools from "../../commons/tools.js";
import { Collapse, CollapseItem, Tab, Tabs, Toast, NumberKeyboard } from "vant";

export default {
  data() {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      shuoming: "",
      HomeConfigs: {}, //配置
      IsShowCart: true,
      tools: tools,

      PreviewsItems: [], //预览弹窗
      PreviewsModel: {
        Collections: [],
        Categorys: [],
        Products: [],
      },
    };
  },
  name: "App",
  mounted() {
    this.GetPreviewProductSimple();
  },
  components: {
    productBbroadwise,
    tabbar,
    LanguageSelect,
  },
  methods: {
    ReturnPage() {
      history.back();
    },
    //套餐预览
    StoreCollectionPreviewDetail(item) {
      this.$router.push({
        path: "storePreviewCollection",
        query: {
          collectionId: item.Id,
        },
      });
    },

    //分类预览
    StoreCategoryPreviewDetail(item) {
      this.$router.push({
        path: "storePreviewCategory",
        query: {
          categoryId: item.Id,
        },
      });
    },
    //预览商品
    StorePreviewDetail(item) {
      this.$router.push({
        path: "storePreviewDetail",
        query: {
          productId: item.Id,
        },
      });
    },
    // 查询预览数据
    GetPreviewProductSimple() {
      axios.apiMethod(
        "/Store/StoreOrder/GetPreviewProductSimple",
        "get",
        {},
        (result) => {
          this.PreviewsModel = result.Data;
          // this.PreviewsItems = result.Data;
        }
      );
    },

    GetHomeType() {
      axios.apiMethod(
        "/Store/StoreOrder/GetHomeType",
        "get",
        { tableId: this.TableId },
        (result) => {
          this.HomeConfigs = result.Data;
          this.shuoming = this.HomeConfigs.shuoming;

          localStorage.setItem(
            "addcartDetailed",
            this.HomeConfigs.addcartDetailed ? "yes" : "no"
          );
          localStorage.setItem(
            "IsShowOverProduct",
            this.HomeConfigs.IsShowOverProduct ? "yes" : "no"
          );
          localStorage.setItem(
            "UseSecurityCode",
            this.HomeConfigs.useSecurityCode ? "yes" : "no"
          );
          localStorage.setItem(
            "IsStoreCategorySidebar",
            this.HomeConfigs.IsStoreCategorySidebar ? "yes" : "no"
          );

          if (!result.Data.openTable) {
            alert("没有开台，请联系服务员!");
            return;
          }

          //是否启用店内定位
          if (result.Data.locationUsing) {
            this.GetDistance();
            return;
          }

          this.skipHome = this.HomeConfigs.skipHome;
          if (this.skipHome) {
            console.log("店铺设置为跳过首页");
            //跳过首页
            this.GoOrder();
          }
        }
      );
    },
    Skip(item) {
      var tableId = localStorage.getItem("Cache-TableId");
      this.$router.push({
        path: item,
        query: {
          tableId: tableId,
        },
      });
    },
  },
};
</script>
<style>
.shuoming p {
  padding: 0px !important;
  margin: 0px !important;
}
</style>
<style lang="scss" scoped>
.item_price {
  width: 100px;
  line-height: 20px;
  color: #333;
  font-family: "Titillium Web", Arial, sans-serif;
  font-size: 18pt;
  margin-left: 20px;
}

.item_content {
  margin: 0 auto;
  max-width: calc(100% - 10px);
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  margin-top: 15px;

  .pricture_name {
    margin-top: 10px;
    margin-left: 40px;
    color: #333;
    font-size: 16pt;
    width: 80%;
    height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-weight: 500;
  }

  .item_content_area {
    margin: 0 auto;
    margin-top: 10px;
    width: calc(100% - 20px);

    border-radius: 5px;
    text-align: center;
    border-bottom: 1px dashed rgb(166, 163, 163);

    .item_picture {
      background-color: #fff;
      width: 90%;
      max-height: 200px;
    }

    .item_price_cart {
      margin: 0 auto;
      font-size: 9pt;
      width: 95%;

      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      position: relative;

      .description {
        width: 100%;
        padding: 0px 5px;
        overflow: hidden;
        height: 46px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: normal;
      }

      .item_price_cart_bottom {
        position: absolute;
        height: 40px;
        bottom: 0px;
        right: 0px;
        line-height: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .item_price {
          width: 100px;
          line-height: 20px;
          color: #333;
          font-family: "Titillium Web", Arial, sans-serif;
          font-size: 13pt;
          margin-left: 50px;
        }
      }
    }
  }

  .item_content_chengfen {
    height: 20px;
    display: flex;

    .items {
      width: 20px;
      height: 20px;
      border: 1px solid #333;
      margin-left: 5px;
      text-align: center;
    }
  }
}
.previewName {
  margin-left: 5px;
  color: #626262;
  font-size: 11pt;
}
</style>
  